'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002492 from "./presto.-Two-Factor-Auth-View$$anon$92.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002494 from "./presto.-Two-Factor-Auth-View$$anon$94.js";
import * as $j_presto$002etypes$0024$002dSelected$002dCredential$0024 from "./presto.types$-Selected-Credential$.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$91() {
  this.bJ1 = null;
  this.bIT = null;
  this.bIU = false;
  this.bJ2 = null;
  this.bJ3 = false;
  this.bJ6 = null;
  this.bIZ = null;
  this.bJ0 = false;
  this.bIV = null;
  this.bIW = false;
  this.bIX = null;
  this.bIY = false;
  this.bJ4 = false;
  this.bJ5 = false;
  this.bJ1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bJ6 = "SelectedCredential";
}
export { $c_Lpresto_TwoFactorAuthView$$anon$91 as $c_Lpresto_TwoFactorAuthView$$anon$91 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$91.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$91;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$91() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$91 as $h_Lpresto_TwoFactorAuthView$$anon$91 };
$h_Lpresto_TwoFactorAuthView$$anon$91.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bJ1;
});
$p.L = (function() {
  if ((!this.bIU)) {
    this.bIT = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bIU = true;
  }
  return this.bIT;
});
$p.O = (function() {
  if ((!this.bJ3)) {
    this.bJ2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bJ3 = true;
  }
  return this.bJ2;
});
$p.E = (function() {
  return this.bJ6;
});
$p.t = (function() {
  if ((!this.bJ0)) {
    this.bIZ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("credential", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("selected", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bJ0 = true;
  }
  return this.bIZ;
});
$p.M = (function() {
  if ((!this.bIW)) {
    this.bIV = ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002492.$c_Lpresto_TwoFactorAuthView$$anon$92(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().ar, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.bIW = true;
  }
  return this.bIV;
});
$p.Q = (function() {
  if ((!this.bIY)) {
    this.bIX = new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002494.$c_Lpresto_TwoFactorAuthView$$anon$94();
    this.bIY = true;
  }
  return this.bIX;
});
$p.w = (function() {
  if ((!this.bJ5)) {
    this.bJ4 = false;
    this.bJ5 = true;
  }
  return this.bJ4;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee1023) => ((p) => \u03b4scrutinee1023.cGw(p)))($j_presto$002etypes$0024$002dSelected$002dCredential$0024.$m_Lpresto_types$SelectedCredential$())));
});
var $d_Lpresto_TwoFactorAuthView$$anon$91 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$91, "presto.TwoFactorAuthView$$anon$91", ({
  Tv: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$91 as $d_Lpresto_TwoFactorAuthView$$anon$91 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$91.js.map
